export const CLOSED_VOLUME = 'financials.adaptedData.transaction.actual.closePrice.value'
export const HEADER_CLOSE_PRICE = 'closedPrice';